import UserEntitledApps from './UserEntitledApps.component';

export default UserEntitledApps;
